import { Card, CardContent, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
    useForm
} from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { bindDropDown, callAPI, convertToUTCISOString, dateFormat, IsSmallScreen, Method } from "../../../../commonFunctions/CommonFunctions";
import WSAutocompleteField from "../../../../Components/AutoComplete/AutoComplete";
import WSDateTimeField from "../../../../Components/DateField/WSDateTimePicker";
import { HeaderList, IHeaderListActions } from "../../../../Components/Header/HeaderList";
import WSHiddenField from "../../../../Components/HiddenField/WSHiddenField";
import WSSelectField from "../../../../Components/Select/WSSelect";
import { useSnackbar } from "../../../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../../Components/WSTextArea/WSTextArea";
import clientConfig from '../../../../Config/clientConfig.json';
import { ICall } from "../../../DTO/Dto";


export const CreateCallLog: React.FC<any> = (props) => {
    const [leadData, setLeadData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activityDate, setActivityDate] = useState<any>(undefined);
    const [isReminder, setIsReminder] = useState(false);
    const [dealsData, setDealsData] = useState<any>([])
    const [particpants, setparticpants] = useState<any>([])
    const isMobile = IsSmallScreen()
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const { id } = useParams()
    const [loadingSaveAndNew, setLoadingSaveAndNew] = useState(false)
    const { showMessage } = useSnackbar();
    const navigate = useNavigate();
    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    useEffect(() => {
        try {
            async function getLeads() {
                const response: any = await bindDropDown('leads', 'firstName', 'id', Method.GET, ['firstName', 'lasttName'], { field: 'leadType', value: 0 })
                setLeadData(response)
            }
            getLeads()
        }
        catch (e) {
        }
    }, [])
    useEffect(() => {
        const getCalls = async () => {
            try {
                const response: any = await callAPI(`call-logs`, Method.GET, null, id);
                setValue('callType', response?.data?.callType)
                setValue('callStart', dateFormat(response?.data?.callStart, 'DD-MM-YYYY HH:mm:ss'))
                setValue('callDuration', response?.data?.callDuration)
                setValue('subject', response?.data?.subject)
                setValue('callPurpose', response?.data?.callPurpose)
                setValue('leadId', response?.data?.leadId)
                setValue('callResult', response?.data?.callResult)
                setValue('callStatus', response?.data?.callStatus)
                setValue('description', response?.data?.description)
            }
            catch (e) {
            }
        }
        if (id) {
            getCalls();
        }
    }, [id])
    const handleDataSaveAndNew = async (data: any) => {
        try {
            setLoadingSaveAndNew(true)
            const response: any = await saveData(data);
            if (response && response?.message) {

                showMessage(response.message, response.success === true ? 'success' : 'error')
                if (response.success === true) {
                    reset()
                }
            } else if (response?.id) {
                reset()
                showMessage('Deals Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoadingSaveAndNew(false)
        }
    }
    const handleData = async (data: any) => {
        try {
            setLoading(true)
            const response: any = await saveData(data);
            if (response && response?.message) {
                showMessage(response.message, response.success === true ? 'success' : 'error')
                if (response.success === true) {
                    navigate(`/call/list`)
                }
            } else if (response?.id) {
                showMessage('Call Created Successfully', 'success')
                navigate(`/call/list`)
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoading(false)
        }
    }
    const handleCancelClick = () => {
        navigate(`/call/list`)
    }
    const saveData = async (data: ICall) => {
        const callStart: any = convertToUTCISOString(data?.callStart.toString())
        const request: ICall = {
            callType: data?.callType || "",
            callStart: callStart || "",
            callDuration: Number(data.callDuration) || 0,
            callPurpose: data?.callPurpose || "",
            leadId: data.leadId || "",
            callResult: data.callResult || "",
            description: data.description,
            subject: data?.subject || "",
            callStatus: data?.callStatus

        }
        if (data?.callId) {
            const response: any = await callAPI("call-logs", Method.PUT, request, data.callId);
            return response
        } else {
            const response: any = await callAPI("call-logs", Method.POST, request);
            return response
        }

    }
    const actions: IHeaderListActions[] =
        [
            { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
            { type: 'button', disabled:id!==undefined, text: 'Save & New', loading: loadingSaveAndNew, size: 'small', onClick: handleSubmit(handleDataSaveAndNew), buttonType: 'button', variant: 'outlined', color: 'primary' },
            { type: 'button', text: 'Save', loading: loading, size: 'small', onClick: handleSubmit(handleData), buttonType: 'submit', variant: 'outlined', color: 'primary' }
        ]
    return (
        <Grid >
            <HeaderList title={!id?"Create New Call":"Update Call"} type="card" position="relative" actions={actions} isBackButton={true} url="/call/list" />
            {<Card>
                <CardContent>
                    <form>
                        <Grid container spacing={2} mt={0}>
                            <Grid item xs={12}>
                                <Typography fontWeight={"bold"} sx={{ fontSize: '.9rem' }}>Call Information</Typography>
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <WSTextField
                                    rules={{ required: true }}
                                    {...register("subject")}
                                    id="subject"
                                    control={control}
                                    label="Subject"
                                    name="subject"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {leadData && leadData.length > 0 && <WSAutocompleteField
                                    options={leadData}
                                    rules={{ required: true }}
                                    {...register("leadId")}
                                    id="leadId"
                                    isMobile={isMobile}
                                    control={control}
                                    label="Lead"
                                    name="leadId"
                                />}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSSelectField
                                    label={"Call Type"}
                                    {...register("callType")}
                                    id="callType"
                                    name="callType"
                                    options={clientConfig.callTypeSourceConfig.staticOptionData}
                                    control={control}
                                    rules={{ required: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSSelectField
                                    label={"Call Status"}
                                    {...register("callStatus")}
                                    id="callStatus"
                                    name="callStatus"
                                    options={clientConfig.callStatusSourceConfig.staticOptionData}
                                    control={control}
                                    rules={{ required: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSDateTimeField
                                    label={"Call Start"}
                                    // disabled={activityDate !== 'custom'}
                                    id="callStart"

                                    setValue={setValue}
                                    name="callStart"
                                    control={control}
                                    viewClock={false}
                                    rules={{ required: true }}

                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <WSTextField
                                    rules={{ required: true }}
                                    {...register("callDuration")}
                                    id="callDuration"
                                    control={control}
                                    label="Call Duration"
                                    name="callDuration"
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSTextField
                                    rules={{ required: true }}
                                    {...register("callPurpose")}
                                    id="callPurpose"
                                    control={control}
                                    label="Call Purpose"
                                    name="callPurpose"
                                />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <WSTextField
                                    rules={{ required: true }}
                                    {...register("callResult")}
                                    id="callResult"
                                    control={control}
                                    label="Call Result"
                                    name="callResult"
                                />
                            </Grid>



                            <Grid item xs={12} sm={12}>
                                <WSTextAreaField
                                    label={"description"}
                                    {...register("description")}
                                    id="description"
                                    name="description"
                                    control={control}
                                    rules={{ required: true }}
                                    rows={2}
                                />
                            </Grid>
                            <WSHiddenField control={control} name="callId" defaultValue={id} />
                        </Grid >
                    </form>
                </CardContent>
            </Card>
            }
        </Grid >
    );
};

